<template>
  <div class="assignment-progress">
    <v-stepper alt-labels>
      <v-stepper-header>
        <v-stepper-step class="px-0" step="" :complete="true">
          Received
          <small>
            {{ formattedReceivedString }}
          </small>
        </v-stepper-step>

        <v-divider :class="{ laptopSmaller }"></v-divider>
        <v-stepper-step class="px-0" step="" :complete="isInProgress">
          In Progress
        </v-stepper-step>

        <v-divider :class="{ laptopSmaller }"></v-divider>
        <v-stepper-step class="px-0" step="" :complete="isDesigned">
          Design In Progress
        </v-stepper-step>

        <v-divider :class="{ laptopSmaller }"></v-divider>
        <v-stepper-step class="px-0" step="" :complete="isDelivered">
          Delivered
          <small> {{ formattedDeliveryDateString }} </small>
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>

<script>
// internal
import { customBreakpoint, timeUnits } from "@/utils/mixins";

export default {
  name: "AssignmentProgressIndicator",
  props: {
    data: Object,
  },
  mixins: [customBreakpoint, timeUnits],
  computed: {
    formattedReceivedString() {
      return this.formatPickerDate(this.data.schedule.requestDate);
    },
    formattedDeliveryDateString() {
      return `${
        this.data.schedule.deliveryDate ? "by " : ""
      }${this.formatPickerDate(this.data.schedule.deliveryDate)}`;
    },
    isInProgress() {
      const possibleStatus = [
        "Assigned",
        "Primary Complete",
        "Secondary Complete",
        "QC Complete",
      ];

      return possibleStatus.includes(
        this.data.assignmentDetails.assignmentStatus
      );
    },
    isDesigned() {
      return (
        this.data.assignmentDetails.assignmentStatus === "Design in Progress"
      );
    },
    isDelivered() {
      return this.data.assignmentDetails.assignmentStatus === "Delivered";
    },
  },
};
</script>

<style lang="scss" scoped>
.assignment-progress {
  width: 100%;
  > * {
    box-shadow: none;
  }

  > div {
    background-color: transparent;
  }
}
.v-stepper--alt-labels .v-stepper__step {
  flex-basis: 100px;
}
.v-divider {
  flex: 0 1 100px;
  &.laptopSmaller {
    flex: 0 1 75px;
  }
}
::v-deep {
  .v-stepper__label {
    text-align: center;
  }
}
</style>
